import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
  CircularProgress
} from "@material-ui/core";
import { formatMoney } from "../lithic/Money";

export default function AggregatedPaymentPreviewModal({
  open,
  groups,
  onClose,
  onCreate,
  loading
}) {
  if (!groups || !Array.isArray(groups)) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Aggregated Payments</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          The following aggregated payments will be created. Each group
          represents one ACH transfer.
        </Typography>

        {groups.map((group, idx) => (
          <Box key={idx} mb={2} p={2} border={1} borderColor="grey.300" borderRadius={4}>
            <Box display="flex" alignItems="center" style={{ gap: 8 }} mb={1}>
              <Typography variant="subtitle1">
                Group {idx + 1}
              </Typography>
              <Chip
                size="small"
                label={group.payType === "pay_in" ? "Invoice" : "Payout"}
                color={group.payType === "pay_in" ? "secondary" : "primary"}
              />
            </Box>
            <Typography variant="body2">
              Total: {formatMoney(group.total)}
            </Typography>
            <Typography variant="body2">
              Statements: {(group.statementIds || []).length}
            </Typography>

            {group.bankAccount && (
              <Typography variant="body2" color="textSecondary">
                Bank: {group.bankAccount.name || "N/A"}{" "}
                {group.bankAccount.last4
                  ? `(****${group.bankAccount.last4})`
                  : ""}
              </Typography>
            )}

            {group.errors && group.errors.length > 0 && (
              <Box mt={1}>
                {group.errors.map((err, i) => (
                  <Typography key={i} color="error" variant="body2">
                    {err}
                  </Typography>
                ))}
              </Box>
            )}
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onCreate}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} /> : "Create Aggregated Payments"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
